import { Icon } from '@plone/volto/components';
import paintBucketSVG from '@plone/volto/icons/paint.svg';
import heroSVG from '@plone/volto/icons/hero.svg';
import cardsSVG from '@plone/volto/icons/cards.svg';
import iconSVG from '@plone/volto/icons/select-all.svg';
import sliderSVG from '@plone/volto/icons/slider.svg';
import socialSVG from '@plone/volto/icons/share.svg';
import { Edit as CustomHeroEdit, View as CustomHeroView} from './components/Blocks/CustomHero';
import { Edit as ButtonRowEdit, View as ButtonRowView} from './components/Blocks/ButtonRow';
import { Edit as MultiCardEdit, View as MultiCardView } from './components/Blocks/MultiCardBlock';
import { Edit as IconLinkRowEdit, View as IconLinkRowView} from './components/Blocks/IconLinkRow';
import { Edit as EmblaCarouselEdit, View as EmblaCarouselView} from './components/Blocks/EmblaCarousel';
import { Edit as EmblaRatingsEdit, View as EmblaRatingsView } from './components/Blocks/EmblaRatings';
import { Edit as SocialMetaEdit, View as SocialMetaView } from './components/Blocks/SocialMeta';
import { initForceLinksToBlank } from './forceLinksToBlank';

//social sharing button
//import SocialSharing from '@codesyntax/volto-social-sharing/SocialSharing';
//import { DEFAULT_SOCIAL } from '@codesyntax/volto-social-sharing/defaultSettings';
//change twitter to X

const applyConfig = (config) => {
  config.settings.isMultilingual = false;
  config.settings.supportedLanguages = ['en'];
  config.settings.defaultLanguage = 'en';

  config.blocks.themes = [
    {
      style: {
        '--theme-color': 'white',
        '--theme-high-contrast-color': 'var(--blue)',
        '--theme-foreground-color': 'var(--charcoal)',
        '--theme-low-contrast-foreground-color': 'var(--blue)',
        '--link-foreground-color': 'var(--darkblue)',
      },
      name: 'default',
      label: 'Default',
    },
    {
      style: {
        '--theme-color': 'var(--lightgrey)',
        '--theme-high-contrast-color': 'var(--charcoal)',
        '--theme-foreground-color': 'var(--charcoal)',
        '--theme-low-contrast-foreground-color': 'var(--blue)',
        '--link-foreground-color': 'var(--darkblue)',
      },
      name: 'lightgrey',
      label: 'Light Grey',
    },
    {
      style: {
        '--theme-color': 'var(--blue)',
        '--theme-high-contrast-color': 'white',
        '--theme-foreground-color': 'white',
        '--theme-low-contrast-foreground-color': 'white',
        '--link-foreground-color': 'white',
      },
      name: 'darkblue',
      label: 'Dark Blue',
    },
    {
      style: {
        '--theme-color': 'var(--charcoal)',
        '--theme-high-contrast-color': 'white',
        '--theme-foreground-color': 'white',
        '--theme-low-contrast-foreground-color': 'white',
        '--link-foreground-color': 'white',
      },
      name: 'charcoal',
      label: 'Charcoal',
    },
  ];

  //Enable autoplay on Slider
  config.blocks.blocksConfig.slider.enableAutoPlay = true;

  //Adding custom colours and block styles to Slate editor
  config.settings.slate.styleMenu.inlineStyles = [
    ...(config.settings.slate.styleMenu?.inlineStyles || []),
    {
      cssClass: 'text-red',
      label: 'Red Text',
      icon: () => <Icon name={paintBucketSVG} size="18px" color="red" />,
    },
    {
      cssClass: 'text-green',
      label: 'Green Text',
      icon: () => <Icon name={paintBucketSVG} size="18px" color="green" />,
    },
    {
      cssClass: 'text-blue',
      label: 'Blue Text',
      icon: () => <Icon name={paintBucketSVG} size="18px" color="blue" />,
    },
  ];
  config.settings.slate.styleMenu.blockStyles = [
    ...(config.settings.slate.styleMenu?.blockStyles || []),
    {
      cssClass: 'highlight-block',
      label: 'Highlighted Block',
      nodeType: 'paragraph', // Ensures it only applies to paragraph blocks
      icon: () => (
        <div
          style={{
            backgroundColor: 'yellow',
            width: '18px',
            height: '18px',
            borderRadius: '3px',
          }}
        />
      ),
    },
  ];

  //CustomHero
  config.blocks.blocksConfig.customHero = {
    id: 'customHero',
    title: 'Hero Block',
    icon: heroSVG,
    group: 'common',
    view: CustomHeroView,
    edit: CustomHeroEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //ButtonRow
  config.blocks.blocksConfig.buttonRow = {
    id: 'buttonRow',
    title: 'Button Row',
    icon: cardsSVG,
    group: 'common',
    view: ButtonRowView,
    edit: ButtonRowEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //add in social sharing block
  /*config.settings.appExtras = [
    ...config.settings.appExtras,
    {
      match: '',
      component: SocialSharing,
      props: {
        socialElements: DEFAULT_SOCIAL,
      },
    },
  ];*/

  //IconLinkRow
  config.blocks.blocksConfig.iconLinkRow = {
    id: 'iconLinkRow',
    title: 'Icon Link Row',
    icon: iconSVG,
    group: 'common',
    view: IconLinkRowView,
    edit: IconLinkRowEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //Multicard Block
  config.blocks.blocksConfig.multiCard = {
    id: 'multiCard',
    title: 'Multi Card',
    icon: cardsSVG,
    group: 'common',
    view: MultiCardView,
    edit: MultiCardEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //Embla Carousel
  config.blocks.blocksConfig.EmblaCarousel = {
    id: 'EmblaCarousel',
    title: 'Embla Carousel',
    icon: sliderSVG,
    group: 'common',
    view: EmblaCarouselView,
    edit: EmblaCarouselEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //Embla Ratings
  config.blocks.blocksConfig.EmblaRatings = {
    id: 'EmblaRatings',
    title: 'Embla Ratings',
    icon: sliderSVG,
    group: 'common',
    view: EmblaRatingsView,
    edit: EmblaRatingsEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //Social Meta Block
  config.blocks.blocksConfig.socialMeta = {
    id: 'socialMeta',
    title: 'Social Media Meta',
    icon: socialSVG,
    group: 'common',
    view: SocialMetaView,
    edit: SocialMetaEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
  };

  return config;
};

if (typeof window !== 'undefined') {
  initForceLinksToBlank([
    '/about/juizi',
    // add more paths here
  ]);
}

export default applyConfig;
